/* Cervi-Zen — bloc d'offres maison + pop-up complément (fiche oreiller).
   Config : window.CZ_BUNDLE (snippets/cz-bundle.liquid). Panier : window.CZCart.add(items) (assets/cz-cart-drawer.js), sinon /cart/add.js.
   Lignes envoyées : oreiller ×N (_cz_bundle = "1x" | "2x" | "3+1"), taies option ×k (_cz_bundle_option = "taie"),
   LombaZen offre ×1 (_cz_popup = "lombazen"). Les prix des packs viennent des remises automatiques Shopify. */
(function () {
  var C = window.CZ_BUNDLE, root = document.getElementById('czb');
  if (!C || !root) return;
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var list = root.querySelector('.czb__list');
  var state = { offer: C.defaultOffer, taies: {} };
  C.offers.forEach(function (o) { var a = []; for (var i = 0; i < o.n; i++) a.push(true); state.taies[o.n] = a; }); // pré-cochées (décision Guilhem 21/10)

  var T = C.t || {};
  function eur(c) { return C.money === 'usd' ? '$' + (c / 100).toFixed(2) : (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function pct(o) { return Math.round((1 - o.price / o.was) * 100); }
  function offer(n) { for (var i = 0; i < C.offers.length; i++) if (C.offers[i].n === n) return C.offers[i]; }
  function sub(o) {
    if (o.sub === 'ship') return '<span class="ok">' + (T.ship || 'Livraison offerte') + '</span>';
    if (o.sub === '4oreillers') return (T.four || '4 oreillers') + ' · <span class="ok">' + (T.ship || 'Livraison offerte') + '</span>';
    return o.sub || '';
  }

  /* placement : juste avant le bloc des boutons d'achat de la fiche (le snippet est rendu depuis une section du layout) */
  var pf = document.querySelector('product-form.main-product-form') || document.querySelector('product-form');
  if (pf && pf.parentElement && pf.parentElement.parentElement) pf.parentElement.parentElement.insertBefore(root, pf.parentElement);
  root.classList.add('is-placed');
  var popEl = document.getElementById('czpo'); if (popEl) document.body.appendChild(popEl);
  if (C.hideNative) {
    document.documentElement.classList.add('czb-hide-native');
    /* Rapi rend son widget sous plusieurs formes (rapi-bundles, rapi-bundle-content-N en Polaris) : on masque tout */
    var st = document.createElement('style');
    st.textContent = '.czb-hide-native [class*="rapi-bundle-content"],.czb-hide-native .rapi-bundles,.czb-hide-native .rapi-bundle-error{display:none!important}' +
      /* bouton PayPal / paiement express de la fiche : il achèterait 1 oreiller sans le pack choisi (PayPal reste au paiement) */
      '.czb-hide-native product-form .shopify-payment-button,.czb-hide-native product-form [data-shopify="payment-button"]{display:none!important}' +
      /* LombaZen plein tarif retiré des suggestions du panier (déjà proposé à -50 % dans la pop-up) */
      '.czc-upr:has([data-czc-up-add="' + (C.popup ? C.popup.mainVariant : 0) + '"]){display:none!important}';
    document.head.appendChild(st);
  }

  C.offers.forEach(function (o) {
    var el = document.createElement('div');
    el.className = 'czb__card' + (o.hero ? ' czb__card--hero' : '');
    el.setAttribute('role', 'radio'); el.tabIndex = 0; el.dataset.offer = o.n;
    el.innerHTML = (o.ribbon ? '<span class="czb__ribbon' + (o.best ? ' czb__ribbon--best' : '') + '">' + o.ribbon + '</span>' : '') +
      '<div class="czb__main"><span class="czb__radio"></span>' +
      '<div class="czb__thumb"><img src="' + o.img + '" alt="" width="48" height="36"></div>' +
      '<div class="czb__txt"><div class="czb__title">' + o.label + '<span class="czb__badge">-' + pct(o) + ' %</span></div>' +
      (sub(o) ? '<div class="czb__sub">' + sub(o) + '</div>' : '') + '</div>' +
      '<div class="czb__price"><b>' + eur(o.price) + '</b><s>' + eur(o.was) + '</s></div></div>' +
      (C.taie ? '<div class="czb__addons"></div>' : '');
    el.addEventListener('click', function (e) {
      var row = e.target.closest('.czb__addon');
      if (row && state.offer === o.n) { var i = +row.dataset.i; state.taies[o.n][i] = !state.taies[o.n][i]; }
      else state.offer = o.n;
      render();
    });
    el.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); state.offer = o.n; render(); } });
    list.appendChild(el);
  });

  /* rendu : les lignes taies ne sont reconstruites qu'au changement d'offre ; cocher/décocher ne touche qu'à la ligne (pas de clignotement) */
  function rowsHTML(n) {
    return state.taies[n].map(function (on, i) {
      return '<div class="czb__addon ' + (on ? 'is-on' : 'is-off') + '" data-i="' + i + '" role="checkbox" aria-checked="' + on + '"><span class="czb__check">' + CHECK + '</span>' +
        '<img src="' + C.taie.img + '" alt="" width="32" height="32"><span class="czb__addon-t">+ 1 ' + C.taie.title + '</span>' +
        '<span class="czb__addon-p">' + eur(C.taie.price) + (C.taie.was > C.taie.price ? '<s>' + eur(C.taie.was) + '</s>' : '') + '</span></div>';
    }).join('');
  }
  function render() {
    [].forEach.call(list.querySelectorAll('.czb__card'), function (c) {
      var n = +c.dataset.offer, o = offer(n), sel = n === state.offer;
      c.setAttribute('aria-checked', sel);
      var box = c.querySelector('.czb__addons'); if (!box) return;
      var mode = sel ? 'sel' : 'more';
      if (box.getAttribute('data-mode') === mode) {
        if (sel) [].forEach.call(box.querySelectorAll('.czb__addon'), function (r) {
          var on = state.taies[n][+r.dataset.i];
          r.classList.toggle('is-on', on); r.classList.toggle('is-off', !on); r.setAttribute('aria-checked', on);
        });
        return;
      }
      box.setAttribute('data-mode', mode);
      box.innerHTML = sel ? rowsHTML(n) : '<div class="czb__more"><img src="' + C.taie.img + '" alt="" width="24" height="24">+ ' + (o.n > 1 ? o.n + ' ' + (T.covers || 'taies') : '1 ' + (T.cover || 'taie')) + ' ' + (T.optional || 'Satin Platine™ en option') + '</div>';
    });
  }
  render();

  /* bloc « Ce qui rend le Cervi-Zen™ vraiment unique » : remplace les 4 anciennes vidéos par celles avec notre oreiller (16/10) */
  var VID = { 'b35a8cb8e92d4df1b22885bb8aa0809f': '27c2a0df25d0491e8ab234298ca76886', 'e78081764f494ee68602fa746c9189eb': '17ddb0bad3ca4669baaf76ea219c30c3',
    'a6aae72935ca4027a6081db381e1978b': '458dcd8cd44d46a9a2dc9add11edf0a5', '796fbb37a13244b0b3d4a07b193a639a': 'c0ffd07d246b48d28c271f6539aa105e' };
  [].forEach.call(document.querySelectorAll('video'), function (v) {
    var hit = false;
    [].forEach.call(v.querySelectorAll('source'), function (s) { var src = s.getAttribute('src') || ''; Object.keys(VID).forEach(function (k) { if (src.indexOf(k) > -1) { s.setAttribute('src', src.replace(k, VID[k])); hit = true; } }); });
    var vs = v.getAttribute('src') || ''; Object.keys(VID).forEach(function (k) { if (vs.indexOf(k) > -1) { v.setAttribute('src', vs.replace(k, VID[k])); hit = true; } });
    if (hit) { v.load(); if (v.autoplay) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } }
  });

  /* section « Ce que votre oreiller fait à votre colonne » : avant/après refait avec notre oreiller (16/10) */
  [].forEach.call(document.querySelectorAll('img[src*="hf_20260210_112115"]'), function (im) {
    var nu = 'https://cdn.shopify.com/s/files/1/1005/0014/4473/files/cz-avant-apres-colonne.png?width=1200';
    im.removeAttribute('srcset'); im.src = nu;
  });

  /* liens d'ancre vers l'ancienne section produit (id changé à la duplication du thème) : on descend au bloc d'offres */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#shopify-section-template"], a[href="#czb"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1), t = document.getElementById(id);
    if (id !== 'czb' && t && !t.contains(root)) return;
    e.preventDefault();
    window.scrollTo({ top: root.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
  }, true);

  /* ---------- lignes panier ---------- */
  function items() {
    var o = offer(state.offer), k = state.taies[o.n].filter(Boolean).length;
    var tag = o.n === 4 ? '3+1' : o.n + 'x';
    var out = [o.variant ? { id: o.variant, quantity: 1, properties: { _cz_bundle: tag } } : { id: C.pillow, quantity: o.n, properties: { _cz_bundle: tag } }];
    if (C.taie && k) out.push({ id: C.taie.id, quantity: k, properties: { _cz_bundle_option: 'taie' } });
    return out;
  }
  function send(list) {
    if (window.CZCart && window.CZCart.add) return window.CZCart.add(list);
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list })
    }).then(function () { location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; });
  }

  /* ---------- pop-up complément : 1 seule fois par visiteur (30 jours), au 1er ajout ---------- */
  var P = C.popup, pop = document.getElementById('czpo'), timer = null, mem = false;
  function seen() {
    if (mem) return true;
    try { var v = +localStorage.getItem(P.key); if (v && Date.now() - v < P.days * 864e5) return true; } catch (e) {}
    return document.cookie.indexOf(P.key + '=1') > -1;
  }
  function mark() {
    mem = true;
    try { localStorage.setItem(P.key, Date.now()); } catch (e) {}
    document.cookie = P.key + '=1; max-age=' + P.days * 86400 + '; path=/; SameSite=Lax';
  }
  function inCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.items.some(function (i) { return i.variant_id === P.id || i.variant_id === P.mainVariant; }); })
      .catch(function () { return false; });
  }
  function askPopup() {
    return new Promise(function (resolve) {
      if (!P || !pop || seen()) return resolve(false);
      inCart().then(function (has) {
        if (has) return resolve(false);
        mark();
        document.body.appendChild(pop); pop.style.zIndex = '2147483647'; /* au-dessus du bandeau cookies */
        pop.hidden = false; pop.classList.add('is-open');
        var end = Date.now() + 600000, el = pop.querySelector('[data-czp-timer]');
        timer = setInterval(function () {
          var r = Math.max(0, end - Date.now()), m = Math.floor(r / 60000), s = Math.floor(r % 60000 / 1000);
          el.textContent = m + ':' + (s < 10 ? '0' : '') + s; if (!r) clearInterval(timer);
        }, 1000);
        function done(v) {
          clearInterval(timer); pop.classList.remove('is-open'); pop.hidden = true;
          yes.removeEventListener('click', onYes); nos.forEach(function (b) { b.removeEventListener('click', onNo); });
          pop.removeEventListener('click', onBg); resolve(v);
        }
        function onYes() { done(true); }
        function onNo() { done(false); }
        function onBg(e) { if (e.target === pop) done(false); }
        var yes = pop.querySelector('[data-czp-yes]'), nos = [].slice.call(pop.querySelectorAll('[data-czp-no]'));
        yes.addEventListener('click', onYes); nos.forEach(function (b) { b.addEventListener('click', onNo); }); pop.addEventListener('click', onBg);
      });
    });
  }

  /* ---------- interception du bouton « Ajouter au panier » de la fiche ---------- */
  var busy = false;
  function go() {
    if (busy) return; busy = true;
    var base = items();
    askPopup().then(function (yes) {
      if (yes) base.push({ id: P.id, quantity: 1, properties: { _cz_popup: 'lombazen' } });
      return send(base);
    }).catch(function () {}).then(function () { busy = false; });
  }
  function isOurForm(f) {
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return false;
    var id = f.querySelector('[name="id"]');
    return !id || +id.value === +C.pillow || C.offers.some(function (o) { return o.variant && +o.variant === +id.value; });
  }
  window.addEventListener('submit', function (e) {
    if (!isOurForm(e.target)) return;
    e.preventDefault(); e.stopImmediatePropagation(); go();
  }, true);
  /* boutons collants / thèmes qui n'émettent pas de submit */
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cz-bundle-atc], [id^="SectionAtcBtn-"], .sticky-atc button, .sticky-atc__button');
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation(); go();
  }, true);

  window.CZBundle = { items: items, state: state, open: go, resetPopup: function () { mem = false; try { localStorage.removeItem(P.key); } catch (e) {} document.cookie = P.key + '=; max-age=0; path=/'; } };
})();
